export default {
    gridPadding: "16px",
    horizontalGap: "16px",
    verticalGap: "16px",
    backgroundColor: "layout-background-color",
    borderRadius: "8px",
    contentType: null
};
